import React from 'react';
import styled from 'styled-components';

import Top from '../top';
import Section from '../global/section';
import Button from '../global/button';

const StyledDetails = styled.div`
	text-align: center;
	.center {
		margin: 1rem 0;
		.red-bold {
			color: ${(p) => p.theme.color.red};
			font-weight: 700;
			margin-right: 0.25rem;
		}
		.regular {
			margin-right: 1rem;
			font-family: ${(p) => p.theme.fonts.serifBody};
		}
		.info.notes {
			display: block;
			margin-top: 0.5rem;
		}
	}
	hr {
		margin: 1.5rem 0 2rem;
		background-color: ${(p) => p.theme.color.lightGrey};
	}
	.copy {
		font-family: ${(p) => p.theme.fonts.serifBody};
		text-align: left;
	}
	.locations {
		display: flex;
		flex-wrap: wrap;
	}
	.location {
		width: 25%;
		text-align: left;
		margin-top: 1.5rem;
		h3 {
			text-transform: uppercase;
			font-weight: 700;
			font-size: 1rem;
			color: ${(p) => p.theme.color.blue};
		}
		button {
			font-size: 0.8rem;
		}
	}
	@media all and (max-width: 1000px) {
		.location {
			width: 33.3%;
		}
	}
	@media all and (max-width: 768px) {
		.location {
			width: 50%;
		}
	}
	@media all and (max-width: 550px) {
		.location {
			width: 100%;
		}
		.center .info {
			display: block;
			&:nth-child(2) {
				margin-top: 0.5rem;
			}
		}
	}
`;

export default ({ data }) => {
	const { copy, age, genres, notes, locations, heading, top, id } = data;

	return (
		<StyledDetails>
			<Section bg="light" id={id}>
				{top ? (
					<Top color="red">{top}</Top>
				) : (
					<Top color="red">MORE INFORMATION</Top>
				)}
				{heading ? <h2>{heading}</h2> : <h2>Lesson Details</h2>}
				<div className="center">
					{age && (
						<span className="info">
							<span className="red-bold">AGES:</span>
							<span className="regular">{age}</span>
						</span>
					)}
					{genres && (
						<span className="info">
							<span className="red-bold">GENRES:</span>
							<span className="regular">{genres}</span>
						</span>
					)}
					{notes && (
						<span className="info notes">
							<span className="red-bold">NOTES:</span>
							<span className="regular">{notes}</span>
						</span>
					)}
				</div>
				<hr />
				<p className="copy">{copy}</p>
				<div className="locations">
					{locations.map((x, i) => (
						<div className="location" key={i}>
							<h3>{x.title}</h3>
							<Button type="link" to={x.link} size="small" bg="grey">
								FIND OUT MORE
							</Button>
						</div>
					))}
				</div>
			</Section>
		</StyledDetails>
	);
};
